import { WalletProviderType } from "../enum/wallet-provider-type";

export class WalletProvider {
  constructor(
    public name: string,
    public type: WalletProviderType,
    public icon: string,
    public isSocial: boolean = false
  ) {}
}
